<template>
  <div>
    <div class="modal fade" tabindex="-1" role="dialog" id="modalIncluirProduto">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title text-left">Incluir Produto</h4>
            </div>
            <div class="modal-body">
              <div class="form-inline">
                    <div class="form-group ">  
                        <label for="produto">Dados: </label>
                        <input type="text" class="form-control " id="produto" placeholder="Nome Produto" v-model="nome">
                    </div>
                    <div class="form-group "> 
                        <input type="number" min="0" class="form-control " id="quantidade" placeholder="Quantidade Em Estoque" v-model="quantidadeEmEstoque">
                    </div> 
                    <div class="form-group "> 
                        <input type="number" min="0" class="form-control " id="quantidadePorPessoa" placeholder="Quantidade Por Pessoa" v-model="quantidadePorPessoa">
                    </div> 
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="incluir"><i class="fa fa-save" aria-hidden="true"></i> Salvar</button>
            </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
  </div>
</template>
<script>
export default {
  methods: {
    incluir () {
      console.log('incluir')
      let view = {
        Nome: this.nome,
        QuantidadePorPessoa: this.quantidadePorPessoa,
        QuantidadeEmEstoque: this.quantidadeEmEstoque,
        Usuario: { Id: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id },
        Unidade: parseInt(localStorage.getItem('Unidade'))
      }
      this.$http.post('estoque/incluir', view)
        .then(function (res) {
          alert('Produto cadastrado com sucesso')
          location.reload()
        })
    }
  },
  data () {
    return {
      id: '',
      nome: '',
      quantidadePorPessoa: '',
      quantidadeEmEstoque: ''
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// IncluirProduto.vue?6613e03e